import { useState, useEffect } from 'react';

const useTimer = () => {

    const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    }

    useEffect(() => {

        if (!isRunning)
            return;

        const intervalId = setInterval(() => {
            setSeconds(prevSeconds => prevSeconds + 1);
        }, 1000);

        return () => clearInterval(intervalId);
    }, [isRunning]);

    return {
        formatedTime: formatTime(seconds),
        timeInSeconds: seconds,
        reset: () => setSeconds(0),
        start: () => setIsRunning(true),
        stop: () => setIsRunning(false),
    };
}

export default useTimer;